import {css} from "@emotion/react";
import {fontFace, globalStyles} from "@web2/global_styles";
import {themeGh} from "@web2/global_styles";
const fontVariant = "poppins";
const fontPath = `/static-files/fonts/${fontVariant}/`;

export const globalStylesGhMp = css`
    ${fontFace(fontPath, fontVariant, `${fontVariant}_light`, "300", "normal", "swap")};
    ${fontFace(fontPath, fontVariant, `${fontVariant}_regular`, "400", "normal", "swap")};
    ${fontFace(fontPath, fontVariant, `${fontVariant}_medium`, "500", "normal", "swap")};
    ${fontFace(fontPath, fontVariant, `${fontVariant}_semibold`, "600", "normal", "swap")};
    ${fontFace(fontPath, fontVariant, `${fontVariant}_bold`, "700", "normal", "swap")};

    ${globalStyles(themeGh)};

    a:hover,
    a:focus {
        outline: 0;
    }

    html,
    body,
    #root {
        min-height: 100vh;
    }
`;
